<template>
  <div class="ac5">
    <!-- 标题 -->
    <div class="ac5-title">
      <h2>热门话题</h2>
    </div>

    <!-- 循环项 -->
    <div
      class="ac5-item"
      v-for="(item, index) in data"
      :key="index"
      @click="goDays(item.methods, item.id)"
    >
      <!-- 左侧图片 -->
      <div class="item-img">
        <img :src="item.img" alt="" />
      </div>
      <!-- 右侧标题 -->
      <div class="item-title">
        <p>{{ item.title }}</p>
        <span><i class="iconfont icon-time"></i> {{ item.time }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ac5",
  data() {
    return {
      data: [],
    };
  },
  mounted() {
    this.init();
    document.title = "北京敏学科技有限公司";
  },
  methods: {
    init() {
      this.axios.get("/mock/info.json").then((res) => {
        const data = res.data;
        // 两条数据
        this.data = data.splice(6, 10);
        // console.log(this.data);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 收费逻辑
    gopay() {
      if (this.state == 0) {
        // this.$router.push("/pay");
        this.showModal = true;
      }
      // 未登录
      if (this.state !== 0) {
        alert("请登录付费3元后可浏览！！！~");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.ac5 {
  width: 100%;
  // 标题
  .ac5-title {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ccc;
    // padding-left: 30px;
    box-sizing: border-box;
    h2 {
      font-size: 16px;
      width: 80px;
      height: 100%;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid $colorZ;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        color: $colorZ;
      }
    }
  }

  //  循环项
  .ac5-item {
    width: 100%;
    height: 130px;
    // background-color: pink;
    background: #eee;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    margin: 10px auto;
    // 左侧图片
    .item-img {
      width: 130px;
      height: 130px;
      margin-right: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    // 右侧标题
    .item-title {
      font-size: 14px;
      font-weight: bold;
      color: #555;
      cursor: pointer;
      p {
        margin: 20px 0;
        transition: all 0.3s;
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          color: $colorZ;
        }
      }
      span {
        i {
          font-size: 14px;
          margin-right: 5px;
        }
        font-size: 14px;
        color: 888;
      }
    }
  }
}
</style>